import { render, staticRenderFns } from "./newExamManagement.vue?vue&type=template&id=d80559de&scoped=true&"
import script from "./newExamManagement.vue?vue&type=script&lang=js&"
export * from "./newExamManagement.vue?vue&type=script&lang=js&"
import style0 from "./newExamManagement.vue?vue&type=style&index=0&id=d80559de&scoped=true&lang=css&"
import style1 from "./newExamManagement.vue?vue&type=style&index=1&id=d80559de&scoped=true&lang=css&"
import style2 from "./newExamManagement.vue?vue&type=style&index=2&id=d80559de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80559de",
  null
  
)

export default component.exports